import React from 'react';
import { Helmet } from 'react-helmet-async';
import ContactForm41 from '../components/contact-form41';
import Footer from '../components/footer';
import DarkNav from '../components/dark-nav';
import './contact-us.css';

const ContactUs = (props) => {
  return (
    <div className="contact-us-container">
      <Helmet>
        <title>Contact Us - DataFlows SMS Australia</title>
        <meta
          name="description"
          content="Contact the DataFlows support team for any issues or suggestions. We are here to help you with our SMS solutions."
        />
        <link rel="canonical" href="https://dataflows.com.au/contact-us" />
        <meta property="og:title" content="Contact Us - DataFlows SMS Australia" />
        <meta
          property="og:description"
          content="Contact the DataFlows support team for any issues or suggestions. We are here to help you with our SMS solutions."
        />
      </Helmet>
      
      <DarkNav />

      <div className="contact-us-hero-section">
        <div className="contact-us-content">
          <h1 className="contact-us-title">Get in Touch</h1>
          <p className="contact-us-description">
            Have a question, suggestion, or just want to say hello? We&apos;d love to hear from you.
            Please contact the support teams for any issues or suggestions. We&apos;re here to help you!
          </p>
        </div>
      </div>
      
      <div className="contact-us-form-wrapper">
        <ContactForm41 />
      </div>

      <Footer />
    </div>
  );
};

export default ContactUs; 